import React from 'react'
import Product from './Product'
import NavBarPanel from './NavBarPanel'
const Dashboard = () => {
  return (
   <>
    {/* <NavBarPanel /> */}
   <Product/>
   </>
  )
}

export default Dashboard